import {PlusOutlined} from '@ant-design/icons';
import {Button} from 'antd';
import React from 'react';

interface AddButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  variant?: 'green' | 'gray' | 'navy';
}

const PCFAddButton: React.FC<AddButtonProps> = ({
  children,
  onClick,
  variant = 'green'
}: AddButtonProps) => {
  return (
    <Button
      type={variant === 'green' ? 'primary' : 'default'}
      className={`add-btn add-btn-${variant}`}
      onClick={onClick}
      icon={<PlusOutlined />}
    >
      {children}
    </Button>
  );
};
export default PCFAddButton;
